export const key = "0qfo4483lgjvru15";
